import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Favicon = () => {
  const location = useLocation();
  
  useEffect(() => {
    const getTitle = (pathname) => {
      switch (pathname) {
        case '/':
          return 'Dashboard - Vehicle Inspection';
        case '/new-checklist':
          return 'New Checklist - Vehicle Inspection';
        case '/manage-users':
          return 'Manage Users - Vehicle Inspection';
        case '/email-settings':
          return 'Email Settings - Vehicle Inspection';
        case '/login':
          return 'Login - Vehicle Inspection';
        case '/register':
          return 'Register - Vehicle Inspection';
        default:
          if (pathname.startsWith('/checklist/')) {
            return 'Checklist Details - Vehicle Inspection';
          }
          return 'Vehicle Inspection';
      }
    };

    document.title = getTitle(location.pathname);
    
    const metaTags = [
      { property: 'og:title', content: document.title },
      { name: 'twitter:title', content: document.title },
      { name: 'application-name', content: 'Vehicle Inspection' }
    ];

    metaTags.forEach(({ property, name, content }) => {
      let meta = document.querySelector(property ? `meta[property="${property}"]` : `meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        if (property) meta.setAttribute('property', property);
        if (name) meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });
  }, [location]);

  return null;
};

export default Favicon;